<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-08-17 14:57:46
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:39:16
-->
<!--上传文件-->
<template>
	<span class="flex-row flex-align-end">
		<el-upload
			ref="upload"
			:action="action"
			:data="form"
			:limit="limit"
			:file-list="fileList"
			:accept="acceptTypes"
			list-type="picture-card"
			:before-upload="beforeUpload"
			:on-success="onSuccess"
			:on-remove="onRemove"
			:class="{ hide: hideUpload }"
		>
			<div class="default-box">
				<i slot="default" class="el-icon-plus"></i>
				<div class="mt-4 numb" v-if="limit != 99999 && limit > 0">{{ length }}/{{ limit }}</div>
			</div>
		</el-upload>
		<span v-if="showLimitTip" class="yx-color-text-secondary ml-12 line-height-1">{{ limitTip }}</span>
	</span>
</template>
<script>
import { uploadCdnInfo } from '@/api/common';
export default {
	name: 'Upload',
	props: {
		limit: {
			type: [Number, String],
			default: 1,
		},
		showLimitTip: {
			type: Boolean,
			default: false,
		},
		accept: {
			type: Array,
			default: () => ['png', 'jpg', 'jpeg'],
		},
		widthAndHeight: {
			type: Array,
			default: () => [],
		},
		default_img: {
			type: String,
			default: '',
		},
		// 限制上传的大小
		limitSize: {
			type: Number,
			default: 10,
		},
	},
	data() {
		return {
			// 非真实地址
			action: '',
			form: {},
			fileList: [],
			length: 0,
			handCardLink: '',
		};
	},
	watch: {},
	computed: {
		hideUpload() {
			return this.length >= this.limit;
		},
		isLimitWidthAndHeight() {
			return !!this.widthAndHeight.length;
		},
		limitTip() {
			const [width, height] = this.widthAndHeight;
			const acceptTypes = this.accept.map(item => item.toUpperCase()).join('、');
			return `请上传${this.isLimitWidthAndHeight ? `${width}*${height}像素，且` : ''}格式为${acceptTypes}的图片`;
		},
		acceptTypes() {
			return this.accept.map(item => `image/${item.toLowerCase()}`).join(',');
		},
	},
	mounted() {
		const { default_img } = this;
		if (default_img) return this.fileList.push({ url: this.default_img }), (this.length = this.fileList.length);
		this.fileList = [];
		this.length = this.fileList.length;
	},
	methods: {
		async beforeUpload(files) {
			let image_type = files.name.split('.').pop();
			const size = Number((files.size / 1024 / 1024).toFixed(2));
			const limitSize = Number(this.limitSize.toFixed(2));
			const isLt10M = size < limitSize;
			// 检测图片大小是否符合
			if (!isLt10M) {
				this.$message.error(`上传图片大小不能超过 ${this.limitSize}MB!`);
				return;
			}
			// 检测图片尺寸是否符合
			if (this.isLimitWidthAndHeight) {
				try {
					await this.isSize(files);
				} catch (error) {
					const [width, height] = this.widthAndHeight;
					this.$message.error(`上传图片尺寸只能为${width}*${height}像素!`);
					return;
				}
			}
			let params = {
				image_type,
				file_type: 'hand_card',
			};
			let fileName = `${files.uid}-${files.name}`;
			try {
				const res = await uploadCdnInfo(params);
				let { host, accessid, policy, signature, dir } = res.data;
				let key = dir + fileName;
				files.interUrl = host + key; //上传成功后的网络地址
				this.action = host;
				this.form = {
					key,
					policy,
					OSSAccessKeyId: accessid,
					signature,
				};
				return true;
			} catch (error) {
				return false;
			}
		},
		isSize(file) {
			const [width, height] = this.widthAndHeight;
			return new Promise((rs, rj) => {
				const _URL = window.URL || window.webkitURL;
				const img = new Image();
				img.onload = function () {
					let valid;
					//判断是否区间

					if (typeof height === 'string') {
						let arr = height.split('~');
						valid = img.width === width && Number(arr[0]) < img.height <= Number(arr[1]);
					} else {
						valid = img.width === width && img.height === height;
					}

					valid ? rs() : rj();
				};
				img.src = _URL.createObjectURL(file);
			});
		},
		getImgs() {
			const imgs = this.$refs.upload.uploadFiles;
			return imgs.reduce((pre, item) => {
				const { status, url, raw: { interUrl } = {} } = item;
				if (status == 'success') pre.push(interUrl || url);
				return pre;
			}, []);
		},
		setImgs(imgs) {
			imgs = imgs || [];
			this.fileList = imgs.map(item => ({ url: item }));
			this.length = this.fileList.length;
		},
		clearFiles() {
			this.length = 0;
			this.fileList = [];
			this.action = '';
			this.form = {};
			this.$refs.upload.clearFiles();
		},
		onSuccess(response, file, fileList) {
			this.length = fileList.length;
			this.handCardLink = file.raw.interUrl;
			this.$emit('saveCardLink', this.handCardLink);
		},
		onRemove(_, fileList) {
			this.length = fileList.length;
			this.handCardLink = '';
			this.$emit('saveCardLink', this.handCardLink);
		},
	},
};
</script>

<style scoped lang="less">
@width: 104px;
@height: 104px;
/deep/.el-upload--picture-card {
	width: @width;
	height: @height;
	line-height: 1em;
}
/deep/.el-upload-list--picture-card {
	height: 0;
	line-height: 0;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
	width: @width;
	height: @height;
	padding: 8px;
	margin-bottom: 0;
}
/deep/.el-upload-list--picture-card .el-upload-list__item-status-label {
	background: #1890ff;
}
.hide /deep/.el-upload--picture-card {
	display: none;
}
.numb {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.45);
}
.default-box {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>
